import { useState } from 'react';
import { HeroStatTile } from '../components/HeroStatTile';
import { SkelBar, SkelBadge, SkeletonPreviewLabel } from '../components/Skeleton';

/**
 * Archive visual shell. Ports v0.7 ArchivePage (index.html line ~5913).
 *
 * 7.1d update: Empty state replaced with archived signal-row skeletons.
 * Each row matches v0.7's archived-signal layout (line ~5917): muted
 * opacity, tag, company, date metadata, and right-side Restore +
 * Delete actions.
 */
export function Archive() {
  const [search, setSearch] = useState('');

  const archivedRows = [
    { titleW: '74%', tagW: 76, metaW: '46%' },
    { titleW: '62%', tagW: 88, metaW: '38%' },
    { titleW: '82%', tagW: 64, metaW: '52%' },
    { titleW: '56%', tagW: 92, metaW: '42%' },
    { titleW: '70%', tagW: 72, metaW: '48%' },
  ];

  return (
    <div>
      <div className="bdse-hero">
        <div className="bdse-hero-row">
          <div>
            <h1 className="bdse-hero-title">Archive</h1>
            <p className="bdse-hero-subtitle">
              0 archived signals | Restorable anytime
            </p>
          </div>
        </div>

        <div className="bdse-hero-stats">
          <HeroStatTile label="Archived" value="0" sub="signals" icon="archive" />
          <HeroStatTile label="Restorable" value="0" sub="not deleted" icon="history" />
        </div>
      </div>

      <div className="bdse-search-row">
        <input
          type="text"
          value={search}
          onChange={(e) => setSearch(e.target.value)}
          placeholder="Search archived signals..."
          className="bdse-search-input"
          aria-label="Search archived signals"
        />
        {search && (
          <button
            type="button"
            onClick={() => setSearch('')}
            className="bdse-search-clear"
            aria-label="Clear search"
          >
            ×
          </button>
        )}
      </div>

      <SkeletonPreviewLabel text="Sample preview - signals you dismiss from the feed appear here" />

      <div className="bdse-signal-row-list bdse-archive-rows">
        {archivedRows.map((r, i) => (
          <div key={i} className="bdse-signal-row bdse-skeleton-card bdse-archive-row">
            <span
              className="bdse-signal-row-icon"
              style={{ background: 'rgba(0,0,0,0.05)' }}
              aria-hidden="true"
            />
            <span className="bdse-signal-row-content">
              <span className="bdse-signal-row-title">
                <SkelBar w={r.titleW} h={11} />
              </span>
              <span className="bdse-signal-row-meta">
                <SkelBadge w={r.tagW} h={14} />
                <SkelBar w={r.metaW} h={8} />
              </span>
            </span>
            <span
              className="bdse-signal-row-score"
              style={{ background: 'rgba(0,0,0,0.05)' }}
              aria-hidden="true"
            >
              --
            </span>
            <button
              type="button"
              disabled
              title="Coming in Stream 3D"
              className="bdse-btn-secondary-small"
            >
              Restore
            </button>
            <button
              type="button"
              disabled
              title="Coming in Stream 3D"
              className="bdse-btn-ghost-icon"
              aria-label="Delete permanently"
            >
              ✕
            </button>
          </div>
        ))}
      </div>
    </div>
  );
}
